import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

const DeletedUserSchema = new mongoose.Schema({
  userId: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    unique: true,
  },
  firstName: { type: String },
  lastName: { type: String },
  stripeCustomerId: { type: String, unique: true },
  email: { type: String, required: true },
  created: { type: Date, required: true },
  deleted: { type: Date },
  createdGmailLabels: { type: [String] },
  calendarToken: { type: String },
  gmailToken: { type: String },
  hadGmailAccess: { type: Boolean },
  hadCalendarAccess: { type: Boolean },
  location: { type: String },
  hadMobile: { type: Boolean },
  source: { type: String, default: 'ai.multiplayer.work' },
});

export type T_DeletedUser = InferSchemaType<typeof DeletedUserSchema>;

export type T_DeletedUserDocument = T_DeletedUser &
  Document & {
    _id: string;
  };

export { DeletedUserSchema };
